<template>
  <div class="completionEfficiency">
    <el-main style="padding:0;">
      <span style="color: #A52A2A; font-size: 1.6vh; ">
        1.开工率=已开工/全部；2.入库率=已完工/全部；3.发货率=已发运（-当天直发+昨天直发12点前发货 ）/全部(-当天直发+昨天直发)；4.包装率=已包装/全部。
      </span>
      <vm-table
          ref="vmTable"
          style="margin-top: 1vh;"
          :filter.sync="filter"
          :hide-clear="true"
          :no-page="true"
          module="basic"
          url="efficiencyLists">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="开工/交货开始" :vm-search-width="230">
              <el-date-picker
                  v-model="filter.startTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="handleChange"/>
            </vm-search>
            <vm-search label="开工/交货结束" :vm-search-width="230">
              <el-date-picker
                  v-model="filter.endTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="handleChange"/>
            </vm-search>
            <vm-search label="产线">
              <el-select v-model="filter.productionLine" placeholder="请选择" clearable>
                <el-option label="全 部" value=""/>
                <el-option
                    v-for="item in selectorOptions"
                    :key="item.pkid"
                    :label="item.cname"
                    :value="item.cname"/>
              </el-select>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="Column4" align="center" label="名称">
          <template slot-scope="scope">
            {{scope.row.Column4}}{{scope.row.LineName}}
          </template>
        </el-table-column>
        <el-table-column prop="Column1" align="center" label="按单数" width="70"/>
        <el-table-column prop="Column2" align="center" label="按台数" width="70"/>
        <el-table-column prop="Column3" align="center" label="开工/交货日期"/>
      </vm-table>
    </el-main>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import dateUtil from "@/util/dateUtil";

  export default {
    name: "CompletionEfficiency",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          productionLine: "",
          startTime: dateUtil.format(new Date(), "yyyy-MM-dd"),
          endTime: dateUtil.format(new Date(), "yyyy-MM-dd"),
        },
        data: [],
        selectorOptions: [],
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
      this.getSelectorList();
    },
    methods: {
      handleChange() {
        if (this.filter.startTime == null || this.filter.endTime == null) {
          this.$message.error("开工/交货日期不能为空");
        }
      },
      getSelectorList() {
        this.$http
          .get("basic","workLineInfoes/list").then((res) => {
            this.selectorOptions = res;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .completionEfficiency {
    height: 85vh;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
  }
</style>
